
import React, { useState, useEffect } from "react";
import ObjectForm from "../../Common/ObjectForm";
import http from "../../Common/RestAPIHandler";

const JsonDataForm = props => {
	const { jsonSchemaId } = props.match.params;
  const [jsonSchema, setJsonSchema] = useState();
  const [formFields, setFormFields] = useState();
  const [categories, setCategories] = useState();


  useEffect(() => {
    if(jsonSchemaId){
      http.Get(
        `json_schemas/${jsonSchemaId}`,
        (data) => {
          setJsonSchema(data);
        },
        () => {}
      );
    }
    else if(props.objectId){
      http.Get(
        `json_datas/${props.objectId}`,
        (jsonData) => {
          http.Get(
            `json_schemas/${jsonData.json_schema}`,
            (data) => {
              setJsonSchema(data);
            },
            () => {}
          );
        },
        () => {}
      );
    }

    http.Get(
      `categories`,
      (data) => {
        setCategories(data);
      },
      () => {}
    );
  }, [jsonSchemaId]);

  useEffect(() => {
    if(jsonSchema && categories){
      setFormFields([
        {
          id: "json_data",
          label: "JSON DATA",
          type: "json", 
          schema: jsonSchema.json_schema,
          categories: categories
        },
        {
          id: "dataMappings",
          label: "RELATED ENTRIES",
          type: "dataMapping",
          model: "JsonData",
          objectId: props.objectId,
        },
      ]);      
    }
  }, [jsonSchema, categories, props.objectId]);

  return(
    <>
    {jsonSchema && formFields && (
    <ObjectForm 
      {...props} 
      url={`json_datas`} 
      formName={jsonSchema.name} 
      formFields={formFields} 
      object={{ company: props.user.company_id, json_schema:jsonSchemaId, json_data:"{}"}}/>
    )}
    </>
  );
};

export default JsonDataForm;
